// src/components/common/TagInput/TagInput.jsx

import React, { useState, useCallback } from 'react';
import styles from './TagInput.module.css';
import { FiX } from 'react-icons/fi';

const TagInput = ({
    label,
    options = [],
    selectedIds = [],
    onAdd,
    onRemove,
    placeholder = 'Add...',
    disabled = false,
    required = false,
    getOptionLabel = (item) => item?.name || 'N/A',
    getOptionId = (item) => item?.id,
}) => {
    const [selectedValue, setSelectedValue] = useState('');

    const handleAdd = useCallback(() => {
        if (!selectedValue || disabled) return;
        const option = options.find(o => getOptionId(o) === selectedValue);
        if (option && !selectedIds.includes(getOptionId(option))) {
            onAdd(option);
        }
        setSelectedValue('');
    }, [selectedValue, options, selectedIds, onAdd, disabled, getOptionId]);

    const handleKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAdd();
        }
    }, [handleAdd]);

    const availableOptions = options.filter(
        o => !selectedIds.includes(getOptionId(o))
    );

    return (
        <div className={styles.tagInput}>
            {label && (
                <label className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}
            <div className={styles.inputRow}>
                <select
                    value={selectedValue}
                    onChange={(e) => setSelectedValue(e.target.value)}
                    className={styles.select}
                    disabled={disabled}
                >
                    <option value="">{placeholder}</option>
                    {availableOptions.map(option => (
                        <option key={getOptionId(option)} value={getOptionId(option)}>
                            {getOptionLabel(option)}
                        </option>
                    ))}
                </select>
                <button
                    type="button"
                    onClick={handleAdd}
                    className={styles.addButton}
                    disabled={disabled || !selectedValue}
                >
                    +
                </button>
            </div>
            <div className={styles.tagContainer}>
                {selectedIds.length === 0 && (
                    <span className={styles.emptyTagHint}>
                        {label ? `No ${label.toLowerCase()} selected` : 'No items selected'}
                    </span>
                )}
                {selectedIds.map(id => {
                    const option = options.find(o => getOptionId(o) === id);
                    return (
                        <span key={id} className={styles.tag}>
                            {option ? getOptionLabel(option) : 'N/A'}
                            {!disabled && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        const optionToRemove = options.find(o => getOptionId(o) === id);
                                        if (optionToRemove) onRemove(optionToRemove);
                                    }}
                                    className={styles.tagRemoveButton}
                                >
                                    <FiX size={14} />
                                </button>
                            )}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default TagInput;